import { useState } from "react";
import { useWatch } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { TippyV2 } from "@circle-react/components/shared/TippyV2";
import { Form } from "@circle-react-uikit/Form";
import { FormItem } from "../FormItem";
import { PRODUCT_AREAS, TICKET_PRIORITIES, TICKET_TYPES } from "../constants";
import "./styles.scss";

export const SendUsAMessageForm = ({ isLoading }) => {
  const [text, type, area, priority] = useWatch({
    name: ["text", "type", "area", "priority"],
  });
  const isFormDirty = text && type && area && priority;
  const [ticketTypes, setTicketTypes] = useState(TICKET_TYPES);
  const [productAreas, setProductAreas] = useState(PRODUCT_AREAS);
  const [ticketPriorities, setTicketPriorities] = useState(TICKET_PRIORITIES);

  const handleAreaSearch = query => {
    if (query === "") {
      setProductAreas(PRODUCT_AREAS);
    } else {
      const filteredProductAreas = PRODUCT_AREAS.filter(area =>
        area.value.toLowerCase().includes(query.toLowerCase()),
      );
      setProductAreas(filteredProductAreas);
    }
  };

  const handleTypeSearch = query => {
    if (query === "") {
      setTicketTypes(TICKET_TYPES);
    } else {
      const filteredTicketTypes = TICKET_TYPES.filter(ticketType =>
        ticketType.value.toLowerCase().includes(query.toLowerCase()),
      );
      setTicketTypes(filteredTicketTypes);
    }
  };

  const handlePrioritySearch = query => {
    if (query === "") {
      setTicketPriorities(TICKET_PRIORITIES);
    } else {
      setTicketPriorities(
        TICKET_PRIORITIES.filter(priority =>
          priority.text.toLowerCase().includes(query.toLowerCase()),
        ),
      );
    }
  };

  return (
    <div className="flex max-h-full flex-col px-6">
      <FormItem hidePlaceholder={false} name="type">
        <Form.Select
          name="type"
          data={ticketTypes}
          onSearch={handleTypeSearch}
        />
      </FormItem>
      <FormItem hidePlaceholder={false} className="!pt-2" name="area">
        <Form.Select
          name="area"
          data={productAreas}
          onSearch={handleAreaSearch}
        />
      </FormItem>
      <FormItem name="priority" className="!pt-2" hidePlaceholder={false}>
        <Form.Select
          name="priority"
          inputContainerClassName="priority-select-input-container"
          data={ticketPriorities}
          onSearch={handlePrioritySearch}
        />
      </FormItem>
      <FormItem className="!pt-2" name="text">
        <Form.Input
          name="text"
          variant="textarea"
          rows={12}
          className="form-control resize-none"
        />
      </FormItem>
      <div className="my-6 flex justify-between">
        <TippyV2
          placement="left"
          content={t("support_widget.send_message_form.button_tooltip")}
          disabled={isFormDirty}
        >
          <button
            className="bg-circle rounded-lg px-6 py-2.5 font-bold leading-5 text-white hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
            disabled={isLoading || !isFormDirty}
            type="submit"
          >
            {t("support_widget.send_message_form.button_label")}
          </button>
        </TippyV2>
      </div>
    </div>
  );
};
